import React from 'react';
import * as requestLib from '../../lib/requestLib';
import { replaceThumbnails } from '../../thumbnail';
import Colors from './Colors';

class TableTr extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isShowGroupView: false,
            alreadySavedAlert: false,
        };

        this.baseUrl = requestLib.getUrl();
    }

    groupViewShow(boolean) {
        this.setState({
            isShowGroupView: boolean,
        });
    }

    alreadySavedAlert() {
        this.setState({ alreadySavedAlert: true });
    }

    isKeyInObject(articles, key) {
        let names = [];
        articles.map((v) => {
            let indexs = v.science_index ? v.science_index.split(';') : [];
            indexs.map((v2, i) => {
                if (i < 5) {
                    names.push(v2);
                }
            });
        });

        names = names.filter((v) => v != '');
        let set = new Set(names);
        names = [...set];
        return names;
    }
    keywordsHandle(articles) {
        let keywordsArry = [];

        articles.map((v) => {
            v.keywords.map((v2, i) => {
                if (i < 5) {
                    keywordsArry.push(v2);
                }
            });
        });

        let set = new Set(keywordsArry);
        let keywords = [...set];
        return Colors({ list: keywords, type: 'Keywords' });
    }

    replaceImg = (targetData) => {
        return replaceThumbnails[targetData.domain];
    };

    render() {
        let tds = [];
        let data = this.props.trData;

        this.props.titles.map((r, k) => {
            let tdClass =
                k != 0
                    ? r === 'Science Index'
                        ? 'td-list science-index'
                        : 'td-list'
                    : '';
            let nameValue = 'Name';
            let scienceValue = 'Science_Index';
            let article = data.articles;
            let img = data.img;
            const scienceIndex = this.isKeyInObject(article, scienceValue);

            let row;
            if (r === 'Keywords') {
                row = this.keywordsHandle(article);
            } else {
                if (r == 'Image' && img) {
                    row = (
                        <div
                            className="list-img"
                            style={{ backgroundImage: `url(${img}), url(${this.replaceImg(data)})` }}
                        ></div>
                    );
                } else if (r === nameValue) {
                    row = (
                        <div className="name-wrap">
                            <p className="common-name">{data.cname}</p>
                            <p className="scientific-name">
                                {data.sname}
                                <span>({data.domain})</span>
                            </p>
                        </div>
                    );
                } else if (r === 'Science Index') {
                    row = scienceIndex.map((v) => <span>{v}</span>);
                } else {
                    row = <span>{this.props.trData[r]}</span>;
                }
            }

            tds.push(
                <td
                    key={k}
                    onClick={() => {
                        this.props.resultDetail.changePapers(
                            this.props.trData.taxa_id,
                        );
                        this.props.clickDetail();
                    }}
                    className={tdClass}
                >
                    {row}
                </td>,
            );
        });

        return <tr>{tds}</tr>;
    }
}

export default TableTr;



// WEBPACK FOOTER //
// ./src/components/searchResult/TableTr.jsx